import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
var ErrorText = function () {
    return (_jsxs("div", { style: {
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
        }, children: [_jsx("h1", { children: "404 - Page Not Found" }), _jsx("p", { children: "The page you are looking for does not exist." }), _jsx(Link, { to: "/", style: {
                    textDecoration: "none",
                    color: "#3498db",
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "10px"
                }, children: "Go back to Home" })] }));
};
export default ErrorText;
